import { PayloadAction } from '@reduxjs/toolkit';
import { IIpafResult, IIpafQuoteResult } from '../../ipaf/types/IpafResult.types';

export const IpafResultReducer = {
  setIpafResult: (state: IIpafResult, action: PayloadAction<IIpafResult>) => {
    state.company_id = action.payload.company_id;
    state.cnpj = action.payload.cnpj;
    state.customer_deals = action.payload.customer_deals;
    state.message = action.payload.message;
    state.all_rejected = action.payload.all_rejected;
  },
  
  updateQuoteResults: (state: IIpafResult, action: PayloadAction<IIpafQuoteResult[]>) => {
    state.message = action.payload;
  },
  
  clearIpafResult: (state: IIpafResult) => {
    state.company_id = undefined;
    state.cnpj = undefined;
    state.customer_deals = undefined;
    state.message = undefined;
  }
}; 